import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

export default class DmpTracker extends React.Component {
  constructor() {
    super();
    this.trackClicks = this.trackClicks.bind(this);
    this.sendDmpEvents = this.sendDmpEvents.bind(this);
  }

  componentDidMount() {
    this.trackClicks();
  }

  componentDidUpdate() {
    this.trackClicks();
  }

  trackClicks() {
    const elements = document.querySelectorAll(`#${this.props.identifier} [dmptrack]`);
    elements.forEach((element) => {
      element.removeEventListener('click', this.sendDmpEvents);
      element.addEventListener('click', this.sendDmpEvents);
    });
  }

  sendDmpEvents(event) {
    const redirectUrl = event.target.href;
    if (redirectUrl) event.preventDefault();
    const baseUrl = 'https://tags.bluekai.com/site/63962?ret=html';
    const events = get(this.props.eventsList, event.target.id, {});
    const customEvents =
      'dmpData' in event.target.dataset ? JSON.parse(event.target.dataset.dmpData) : {};
    const allEvents = Object.assign({}, events, customEvents);
    let dmpParams = '';
    for (const event in allEvents) {
      dmpParams += `&phint=${event}%3D${allEvents[event]}`;
    }
    if (dmpParams)
      fetch(`${baseUrl}${dmpParams}`, { mode: 'no-cors' })
        .then(() => {
          if (redirectUrl) window.location.href = redirectUrl;
        })
        .catch((err) => {
          if (redirectUrl) window.location.href = redirectUrl;
        });
  }

  render() {
    return <div id={this.props.identifier}> {this.props.children} </div>;
  }
}

DmpTracker.propTypes = {
  identifier: PropTypes.string.isRequired,
  eventsList: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
